import type { ActiveFiler } from '@lt/components/components/HotelCard/components/FiltersPenalized';
import { FiltersPenalized } from '@lt/components/components/HotelCard/components/FiltersPenalized';
import React from 'react';
import styled from 'styled-components';

import { EmptyBlock } from 'src/components/Filters/components/EmptyBlock';
import { FiltersClearButton } from 'src/components/Filters/components/FiltersClearButton';

export type PageDependedProps = {
  activeFilters: ActiveFiler[];
  isMobileHotelFilter?: boolean;
  clearFilters: () => void;
  changeFilter: (filterData: { path: string; diff: unknown }) => void;
  isMapExpanded: boolean;
};

export type CommonProps = {
  isMobile: boolean;
  isHotelOnly: boolean;
};

/**
 * Блок отображается, если на поиске выбраны фильтры, под которые не попадает ни один отель
 */
export const NoFilteredResults = (props: CommonProps & PageDependedProps) => {
  const {
    clearFilters,
    changeFilter,
    activeFilters,
    isMobile,
    isHotelOnly,
    isMobileHotelFilter,
    isMapExpanded,
  } = props;

  const isSmallScreen = isMobile || isMapExpanded;

  const offerType = isHotelOnly ? 'отель' : 'тур';
  if (isMobileHotelFilter) return null;
  return (
    <EmptyBlock isMobile={isSmallScreen}>
      <Title isSmallScreen={isSmallScreen}>
        Под такие фильтры не&nbsp;попал ни&nbsp;один {offerType}
      </Title>
      <Text>
        Под ваши фильтры не подошло ни одного предложения.
        <br />
        Поищите на другие даты или просто сбросьте фильтр
      </Text>

      <ActiveFiltersList>
        <FiltersPenalized
          isMobile={isSmallScreen}
          penalized_filters={activeFilters}
          onChangeFilter={changeFilter}
        />
      </ActiveFiltersList>

      <RemoveFiltersWrapper isSmallScreen={isSmallScreen}>
        <FiltersClearButton onClick={clearFilters} />
      </RemoveFiltersWrapper>
    </EmptyBlock>
  );
};

const Title = styled.span<{ isSmallScreen: boolean }>`
  text-align: center;
  font-weight: bold;
  font-size: ${({ isSmallScreen }) => (isSmallScreen ? 22 : 28)}px;
  line-height: ${({ isSmallScreen }) => (isSmallScreen ? 26 : 34)}px;
`;

const Text = styled.div`
  font-size: 16px;
  line-height: 20px;
  color: #4d4d4d;
  margin: 8px 0px 16px;
  text-align: center;
`;

const ActiveFiltersList = styled.ul`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;
const RemoveFiltersWrapper = styled.div<{ isSmallScreen: boolean }>`
  margin: 16px auto;
  max-width: 288px;
  height: 48px;
  width: ${({ isSmallScreen }) => (isSmallScreen ? '100%' : 'auto')};
`;
